import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { IRenderingContextDefinition } from '@wix/site-service-rendering-context/definition'
import type { SiteRenderingContextServiceSiteConfig } from './types'
import { name } from './symbols'
import { RenderingContextDefinition as definition } from '@wix/site-service-rendering-context/definition'
import { RenderingContextService as impl } from '@wix/site-service-rendering-context/implementations'

export const siteRenderingContextService: FactoryWithDependencies<
	ServiceProvider<IRenderingContextDefinition, typeof impl>
> = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(siteFeatureConfig: SiteRenderingContextServiceSiteConfig) => {
		return {
			definition,
			impl,
			config: siteFeatureConfig,
			platformConfig: siteFeatureConfig,
		}
	}
)
